module.exports = __webpack_public_path__ + "media/images/IKpartner-6a395dc5.png";